import i18n from '../../i18n';

export function LanguageSwitch() {
  const unitedStatesFlag = require('../../assets/images/unitedStatesFlag.png');
  const brazilFlag = require('../../assets/images/brazilFlag.png');
  const domRepFlag = require('../../assets/images/dominicianRepublicFlag.png');
  // const spanishFlag = require('../../assets/images/spainFlag.png');

  const handleChangeLanguage = (selectedLanguage: string) => {
    localStorage.setItem('language', selectedLanguage);
    i18n.changeLanguage(selectedLanguage);
  };

  return(
    <div style={{ display: 'flex', flexDirection: 'row', gap: 10 }}>
      <img
        src={brazilFlag}
        onClick={() => handleChangeLanguage('ptBr')}
        alt="Brazil's Flag"
        style={{ width: 35, cursor: 'pointer' }}
      />

      <img
        src={unitedStatesFlag}
        onClick={() => handleChangeLanguage('en')}
        alt="United States's Flag"
        style={{ width: 35, cursor: 'pointer' }}
      />

      <img
        src={domRepFlag}
        onClick={() => handleChangeLanguage('es')}
        alt="Dominician Republic's Flag"
        style={{ width: 35, cursor: 'pointer' }}
      />
    </div>
  );
}

